"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _mediaQueries = _interopRequireWildcard(require("../../shared/mediaQueries"));
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var double = function double(prop) {
  return "calc(" + prop + " * 2)";
};
var Grid = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1k3hvvk0"
})("width:100%;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;& > *{width:", function (props) {
  return "calc(" + 100 / props.size + "% - " + props.gutter + ")";
}, ";margin-bottom:", function (props) {
  return double(props.gutter);
}, ";", (0, _mediaQueries.default)('lg'), "{width:", function (props) {
  return "calc(" + 100 / (0, _mediaQueries.getProperty)(props, 'size', 'lg') + "% - " + (0, _mediaQueries.getProperty)(props, 'gutter', 'lg') + ")";
}, ";margin-bottom:", function (props) {
  return double((0, _mediaQueries.getProperty)(props, 'gutter', 'lg'));
}, ";}", (0, _mediaQueries.default)('md'), "{width:", function (props) {
  return "calc(" + 100 / (0, _mediaQueries.getProperty)(props, 'size', 'md') + "% - " + (0, _mediaQueries.getProperty)(props, 'gutter', 'md') + ")";
}, ";margin-bottom:", function (props) {
  return double((0, _mediaQueries.getProperty)(props, 'gutter', 'md'));
}, ";}", (0, _mediaQueries.default)('sm'), "{width:", function (props) {
  return "calc(" + 100 / (0, _mediaQueries.getProperty)(props, 'size', 'sm') + "% - " + (0, _mediaQueries.getProperty)(props, 'gutter', 'sm') + ")";
}, ";margin-bottom:15px;}}");
var _default = Grid;
exports.default = _default;